import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import { NavLink, useResolvedPath, useMatch } from 'react-router-dom';

interface DashboardNavItemProps {
  item: {
    text: string;
    icon: React.ReactNode;
    path: string;
  };
  onClick: (path: string) => void;
}

const DashboardNavItem: React.FC<DashboardNavItemProps> = ({ item, onClick }) => {
  const theme = useTheme();

  // Hooks are now called at the top level of this component
  const resolved = useResolvedPath(item.path);
  const match = useMatch({ path: resolved.pathname, end: item.path === '' });

  return (
    <ListItem key={item.text} disablePadding>
      <ListItemButton
        component={NavLink}
        to={item.path} // Use relative path for NavLink
        end={item.path === ''} // Ensure exact match for Overview base path
        onClick={() => onClick(item.path)} // Call passed onClick handler
        selected={!!match} // Use match to determine selected state
        sx={{
          ...(!!match && {
            backgroundColor: theme.palette.action.selected,
            fontWeight: 'bold',
            '& .MuiListItemIcon-root': {
              color: theme.palette.primary.main,
            },
          }),
        }}
      >
        <ListItemIcon
          sx={{ color: !!match ? theme.palette.primary.main : 'inherit' }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText primary={item.text} />
      </ListItemButton>
    </ListItem>
  );
};

export default DashboardNavItem; 